import React from 'react';

export const CastIcon = ({
  width = '20',
  height = '16',
  color = '#5183EB',
  'aria-hidden': ariaHidden = true,
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden={ariaHidden}
    {...rest}
  >
    <path
      d="M1.66699 11.4193C2.46774 11.5826 3.20278 11.9778 3.78064 12.5556C4.35851 13.1335 4.75369 13.8685 4.91699 14.6693M1.66699 8.04427C3.35932 8.23249 4.93722 8.99098 6.14125 10.195C7.34529 11.399 8.10377 12.9769 8.29199 14.6693M1.66699 4.66927V3.0026C1.66699 2.56058 1.84259 2.13665 2.15515 1.82409C2.46771 1.51153 2.89163 1.33594 3.33366 1.33594H16.667C17.109 1.33594 17.5329 1.51153 17.8455 1.82409C18.1581 2.13665 18.3337 2.56058 18.3337 3.0026V13.0026C18.3337 13.4446 18.1581 13.8686 17.8455 14.1811C17.5329 14.4937 17.109 14.6693 16.667 14.6693H11.667M1.66699 14.6693H1.67533"
      stroke={color}
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
